import { CreateSavedSearchArgs } from 'types/api/arguments/create-saved-search-args'
import { SavedSearchResp } from 'types/api/response/saved-search-resp'

import { api } from './api'
import { moneyObjectHeader } from './money-object-header'

export const createSavedSearch = ({ userId, search }: CreateSavedSearchArgs) =>
  api.post<SavedSearchResp>(
    `/users/${userId}/searches`,
    {
      search,
    },
    { headers: moneyObjectHeader },
  )
